import React, { useState } from 'react';
import PropTypes from 'prop-types';

function Pin({
  hidden = false, showPopup = false, text, x, y,
}) {
  const width = (text.length * 6) + 11;

  const [isHovering, setIsHovering] = useState(false);

  return (
    <g
      className={`c-track-map__pin-wrapper ${hidden ? 'c-track-map__pin-wrapper--hidden' : ''}`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <circle className="st5" cx={x} cy={y} r="9" />
      <circle className="st5" cx={x} cy={y} r="7" />
      <circle className="st4" cx={x} cy={y} r="5" />

      <foreignObject
        className={`c-track-map__track-svg-popup ${showPopup || isHovering ? 'c-track-map__track-svg-popup--visible' : ''}`}
        style={{
          width,
          x: x - (width / 2),
          y: y - 40,
        }}
      >
        {text}
      </foreignObject>
    </g>
  );
}

Pin.propTypes = {
  text: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  showPopup: PropTypes.bool,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
};

export default Pin;
